import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

export const shopifyButton = theme => css`
  background-color: ${theme.color.primary.info};
  border-color: ${theme.color.primary.info};
  width: 100%;
  height: ${rem(48)};

  :disabled {
    background-color: ${theme.color.primary.info};
    border-color: ${theme.color.primary.info};
    opacity: 0.4;
  }

  :hover,
  :active {
    background-color: #481fe3;
    border-color: #481fe3;
  }
`

export const oauthErrorContainer = css`
  width: 100%;
  background-color: #ffe5e5;
  color: #ff4242;
  text-align: center;
  font-weight: 500;
  padding: ${rem(16)} ${rem(4)};
`

export const styles = {
  shopifyButton,
  oauthErrorContainer,
}
